export default "__VITE_ASSET__680af8a7__"